/* RepeatDayOfWeekOfMonthRenderer.js */

"use strict";
const BaseScheduleRenderer = require("../../base/BaseScheduleRenderer");
const RendererUtils = require("../../base/RendererUtils");
const DateTimePickerPopup = require("../../common_components/date_time_picker_popup/DateTimePickerPopupComponent");
const DowcComponent = require("../../grid_row_components/dowc_picker_component/DowcPickerComponent");
const StartEndComponent = require("../../grid_row_components/start_end_component/StartEndComponent");

class RepeatDayOfWeekOfMonthRenderer extends BaseScheduleRenderer {
    constructor(model) {
        super(model);
    }
    render(formContainerElem) {
        if (this.isRendered()) {
            return Promise.resolve();
        }
        return Promise.resolve()
            .then(() => {
                this._dowcComp = new DowcComponent(this._model);
                this._atPickerComp = new DateTimePickerPopup(this._model, "time");
                this._startEndComp = new StartEndComponent(this._model);
                return this._dowcComp.renderer.render(formContainerElem);
            })
            .then(() => {
                this._atParts = RendererUtils.groupGridRowElements(
                    formContainerElem,
                    "at",
                    "At",
                    this._atPickerComp
                );
                return this._atPickerComp.renderer.render();
            })
            .then(() => {
                return this._startEndComp.renderer.render(formContainerElem);
            })
            .then(() => {
                this._setTheme(this._model.theme);
                this._registerListeners();
                this.setRendered(true);
            });
    }
    getParts() {
        return this._atParts.concat(this._dowcComp, this._startEndComp);
    }
    shutdown() {
        if (!this.isRendered()) {
            return Promise.resolve();
        }
        return Promise.resolve()
            .then(() => {
                this._unregisterListeners();
                return Promise.all([
                    super.shutdown(),
                    this._dowcComp.shutdown(),
                    this._atPickerComp.shutdown(),
                    this._startEndComp.shutdown(),
                ]);
            })
            .then(() => {
                this._dowComp = undefined;
                this._atPickerComp = undefined;
                this._atParts = undefined;
                this._startEndComp = undefined;
            })
            .catch((err) => {
                console.error(err);
            });
    }
    _setControlValuesFromModel() {}
}

module.exports = RepeatDayOfWeekOfMonthRenderer;
